import React from 'react';
import { Typography, Container, Box } from '@mui/material';

const HomePage = () => {
  return (
    <Container>
      <Box my={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          Welcome to Western MA Kids Activities!
        </Typography>
        <Typography variant="body1" paragraph>
          Discover a variety of camps and activities for kids in Western Massachusetts.
        </Typography>
        <Typography variant="body1" paragraph>
          Check out this year's <a href="/summer-2026">Summer 2026</a> camps.
        </Typography>
      </Box>
    </Container>
  );
};

export default HomePage;